<script setup lang="ts">
const props = defineProps<{
  userInfosProfile: any;
  currentUserLevelName: string;
  currentUserLevelImage: string;
}>();

const emit = defineEmits<{
  (e: 'updateProfile', event: any): void;
  (e: 'editAvatar', event: any): void;
}>();
</script>

<template>
  <div>
    <div
      class="avatar-section-button-update"
      @click="emit('updateProfile', $event)"
    >
      <NuxtIcon name="sync" />
    </div>
    <div
      class="avatar-section-button-edit"
      @click="emit('editAvatar', $event)"
    >
      <NuxtIcon name="pen_square" />
    </div>
    <div
      class="avatar-section-user-avatar avatar-section-gloss"
      :style="`background-image: url(${props.userInfosProfile.avatar_url});`"
    ></div>
    <div class="avatar-section-level-badge">
      <img
        :alt="props.currentUserLevelName"
        :src="props.currentUserLevelImage"
      />
      {{ props.currentUserLevelName }}
    </div>
  </div>
</template>

<style lang="postcss">
.avatar-section-button-update {
  @apply absolute top-4 left-4 text-texts/40 text-sm cursor-pointer;
}

.avatar-section-button-edit {
  @apply absolute top-4 right-4 text-texts/40 text-sm cursor-pointer;
}

.avatar-section-user-avatar {
  @apply bg-contain bg-no-repeat bg-center cursor-pointer mx-auto my-0 rounded-full w-[140px] h-[140px] md:w-[220px] md:h-[220px];
}

.avatar-section-level-badge {
  @apply py-1.5 pl-2 pr-3 md:py-2 md:pl-3 md:pr-4 relative max-w-[100%] flex items-center justify-center bg-bg-primary rounded-full -mt-4 md:-mt-6 mx-auto z-10 text-center gap-1 text-texts text-xs md:text-sm font-semibold whitespace-nowrap;
  img {
    @apply w-[20px] md:w-[26px];
  }
}
</style>
